<template>
    <div class="myInvoice">
        <template v-for="item,index in listData">
            <template v-for="(n,nIndex) in item.list">
                <template v-for="(invoice,iIndex) in n[0].items">
                    <template>
                        <el-card class="box-card">
                            <div class="cardTitle flexbox">
                                <span>{{item.batch_name}}</span>
                                <span
                                    style="font-size:12px; "
                                    class="theme-color"
                                    v-if="invoice.invoice_status==3"
                                >·开票中</span>
                                <span
                                    style="font-size:12px; "
                                    class="uninvoice"
                                    v-if="invoice.invoice_status==0"
                                >·未开票</span>
                                <span
                                    style="font-size:12px; "
                                    class="success"
                                    v-if="invoice.invoice_status==1"
                                >·已开票</span>
                                <span
                                    style="font-size:12px; "
                                    class="invoiceFail"
                                    v-if="invoice.invoice_status==2"
                                >·开票失败</span>
                            </div>
                            <div class="cardCol">
                                <span>订单号</span>
                                <span>{{invoice.order_no}}</span>
                            </div>
                            <div
                                class="cardCol"
                                v-if="n[0].invoice_type!=3&&showInfo==1"
                            >
                                <span>发票抬头</span>
                                <span>{{invoice.invoice_title!=""?invoice.invoice_title:"——"}}</span>
                            </div>
                            <div
                                class="cardCol"
                                v-if="n[0].invoice_type!=3&&showInfo==1"
                            >
                                <span>税号</span>
                                <span>{{invoice.invoice_tax_no!=""?invoice.invoice_tax_no:"——"}}</span>
                            </div>
                            <div class="cardCol">
                                <span>金额</span>
                                <span>{{invoice.total_amount}}元</span>
                            </div>
                            <div class="invoiceBtn flexbox">
                                <el-button
                                    class="aply"
                                    type="primary"
                                    @click="modifyInvoice(invoice,item.batch_id,n[0].is_enable,n[0].invoice_type)"
                                    v-if="invoice.invoice_switch==1"
                                >补录</el-button>
                                <template v-if="invoice.invoice_status!=-99">
                                    <el-button
                                        class="aply"
                                        type="primary"
                                        @click="applyInvoice(invoice,item.batch_id)"
                                        v-if="invoice.invoice_status==0"
                                    >申请开票</el-button>
                                    <el-button
                                        class="aply"
                                        type="primary"
                                        @click="applyInvoice(invoice,item.batch_id)"
                                        v-if="invoice.invoice_status==2||invoice.invoice_status==-1||invoice.invoice_status==-2||invoice.invoice_status==-3||invoice.invoice_status==-4"
                                    >申请失败，重新申请</el-button>
                                    <a :href="invoice.pdf_url">
                                        <el-button
                                            class="aply"
                                            type="primary"
                                            v-if="invoice.invoice_status==1"
                                        >
                                            开票成功,
                                            电子发票下载
                                        </el-button>
                                    </a>

                                </template>

                                <el-button
                                    class="edit"
                                    v-if="invoice.is_valid==1"
                                    @click="modifyInvoice(invoice,item.batch_id,n[0].is_enable,n[0].invoice_type)"
                                >修改</el-button>
                                <el-button
                                    class="edit"
                                    v-if="invoice.red_invoice_apply==1"
                                    @click="handleRedRush(invoice,item.batch_id)"
                                >发票红冲</el-button>
                            </div>
                        </el-card>
                    </template>
                </template>
            </template>
        </template>
    </div>

</template>
<script type="text/ecmascript-6">
export default {
    data: function() {
        return {};
    },
    props: {
        listData: {
            type: Array,
            default: function() {
                return [];
            }
        },
        showInfo: {
            type: Number,
            default: 2
        }
    },
    methods: {
        handleRedRush(invoice, batch_id) {
            this.$emit("handleRedRush", invoice, batch_id);
        },
        applyInvoice(invoice, batch_id) {
            this.$emit("applyInvoice", invoice, batch_id);
        },
        modifyInvoice(invoice, batch_id, is_enable, invoice_type) {
            this.$emit(
                "modifyInvoice",
                invoice,
                batch_id,
                is_enable,
                invoice_type
            );
        }
    }
};
</script>
<style lang="scss">
.myInvoice,
.invoiceApplyList {
    display: flex;
    flex-wrap: wrap;
    .title {
        font-size: 16px;
        font-weight: 600;
        color: #666;
        margin: 10px 0;
    }
    .box-card {
        margin: 30px 15px;
        width: 380px;
        height: 280px;
        border-radius: 20px;
        box-sizing: border-box;
        padding: 20px;
        position: relative;
        .cardTitle {
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
            span {
                &:nth-of-type(1) {
                    font-weight: 600;
                    color: #343434;
                }
            }
        }
        .cardCol {
            display: flex;
            margin-bottom: 10px;
            span {
                &:nth-of-type(1) {
                    display: inline-block;
                    width: 80px;
                    line-height: 20px;
                    color: #959595;
                }
                &:nth-of-type(2) {
                    display: inline-block;
                    width: 245px;
                    line-height: 20px;
                    white-space: wrap;
                    color: #353535;
                }
            }
        }
        .invoiceBtn {
            flex-direction: row-reverse;
            bottom: 20px;
            right: 40px;
            position: absolute;
            a {
                color: white;
            }
            button {
                display: inline;
                height: 30px;
                padding: 0 12px;
                font-size: 12px;
                margin: 0;
                border-radius: 12px;
                margin-left: 10px;
            }
        }
    }
    .moreInfo {
        text-align: right;
        color: #d3d3d3;
        font-size: 12px;
        margin: 10px 0;
        .moretap {
            color: #7e7d7c;
            margin: 0 10px;
        }
    }
    .invoiceList {
        flex-wrap: wrap;
        justify-content: space-between;
    }
    .success {
        color: #45ab00;
    }

    .invoiceFail {
        color: #d0021b;
    }
    .uninvoice {
        color: #f5a623;
    }
    .el-dialog {
        width: 700px;
    }
}
</style>